import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@9b3kuq5phwuk4txw/kiban-react-ui/primitives'
import { Link, useRouterState } from '@tanstack/react-router'
import { CheckSquare, Home, List, Share2, User } from 'lucide-react'
import { useAuthStore } from '@/stores/auth'

interface NavItem {
  to: string
  icon: React.ComponentType<{ className?: string }>
  label: string
}

const homeItems: NavItem[] = [
  { to: '/opportunities', icon: Home, label: 'Home' },
  { to: '/opportunities/mypage', icon: User, label: 'マイページ' },
]

const opportunityItems: NavItem[] = [{ to: '/opportunities/list', icon: List, label: 'オポチュニティ一覧' }]
const captainOnlyItems: NavItem[] = [{ to: '/opportunities/public', icon: Share2, label: '公開オポチュニティ一覧' }]

const taskItems: NavItem[] = [{ to: '/opportunities/tasks', icon: CheckSquare, label: '担当タスク一覧' }]

export function OpportunitiesSidebar() {
  const user = useAuthStore((state) => state.user)
  const isCaptain = user?.isCaptain ?? false
  const router = useRouterState()
  const currentPath = router.location.pathname

  const isActive = (to: string) => currentPath === to

  const visibleOpportunityItems = isCaptain ? [...opportunityItems, ...captainOnlyItems] : opportunityItems
  return (
    <Sidebar className='h-full'>
      <SidebarHeader>
        {/* TODO: 色が強すぎてカッコ悪いので、テキストにしておきます */}
        {/* <img src={logoUrl} alt='オポチュニティ管理' className='w-full h-auto' /> */}
        <h1 className='text-2xl'>オポチュニティ管理</h1>
      </SidebarHeader>
      <SidebarContent className='h-full overflow-auto'>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              {homeItems.map((item) => (
                <SidebarMenuItem key={item.to}>
                  <SidebarMenuButton asChild isActive={isActive(item.to)}>
                    <Link to={item.to}>
                      <item.icon />
                      <span>{item.label}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
        <SidebarGroup>
          <SidebarGroupLabel>オポチュニティ</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {visibleOpportunityItems.map((item) => (
                <SidebarMenuItem key={item.to}>
                  <SidebarMenuButton asChild isActive={isActive(item.to)}>
                    <Link to={item.to}>
                      <item.icon />
                      <span>{item.label}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
        <SidebarGroup>
          <SidebarGroupLabel>タスク</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {taskItems.map((item) => (
                <SidebarMenuItem key={item.to}>
                  <SidebarMenuButton asChild isActive={isActive(item.to)}>
                    <Link to={item.to}>
                      <item.icon />
                      <span>{item.label}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  )
}
